
import { Mutation, MutationTree } from "vuex";
import State from "./state";
import { IUserLoginInfoModel } from "src/model";

/**
 * 更新用户登入信息
 * @param state 
 * @param {IUserLoginInfoModel} profile 
 */
export function SET_PROFILE(state: State, profile: IUserLoginInfoModel): void
{
    state.profile = profile;
    
    if (profile)
    {
        localStorage.setItem("profile", JSON.stringify(profile));
    }
}

export default <MutationTree<State>>
{
    SET_PROFILE
};
